import { render, staticRenderFns } from "./CommonDocsForm.vue?vue&type=template&id=4a7e86c6&"
import script from "./CommonDocsForm.vue?vue&type=script&lang=js&"
export * from "./CommonDocsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports